export default "__VITE_ASSET__Dqa42yHz__"